import axios from "axios";

export const headersData = () => {
    return axios
      .get("/sliders")
      .then((response) => {
        // console.log(response.data);
        return response;
      });
  };